<template>
  <div>
    <div :id="identifier" class="ch-Payment_PayPalWrapper"></div>
  </div>
</template>

<script>
export default {
  name: "CheckoutPaymentsPayPalPlus",
  props: {
    identifier: {
      type: String,
      default: "ppplus",
    },
    approvalUrl: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      paypalData: {
        approvalUrl: this.approvalUrl,
        placeholder: this.identifier,
        mode: this.mode,
        country: "DE",
        language: "de_DE",
        preselection: "paypal",
        buttonLocation: "inside",
        useraction: "commit",
        surcharging: "false",
        showLoadingIndicator: true,
        styles: {
          psp: {
            "font-family": "Helvetica",
            "font-size": "16px",
          },
        },
      },
    };
  },
  mounted() {
    const paypal = new Promise(resolve => {
      const script = document.createElement("script");
      script.setAttribute("src", "https://www.paypalobjects.com/webstatic/ppplus/ppplus.min.js");
      script.onload = () => resolve();
      document.head.appendChild(script);
    });
    paypal.then(() => {
      this.activate();
    });
  },
  methods: {
    activate() {
      window.PAYPAL.apps.PPP(this.paypalData);
    },
  },
};
</script>
